import { Stack, Typography } from '@mui/material';
import { variants } from '../../../variants/variants';
import empty from '../../../assets/empty.png';
const NoTeam = () => {
  return (
    <Stack alignItems={'center'} justifyContent={'center'} sx={{ p: 2, mt: 2, height: '100%' }}>
      <img style={{ width: '60%' }} src={empty} alt='pending' />
      <Typography sx={{ fontSize: variants.TINY, p: 1, color: 'rgba(0,0,0,0.7)' }}>Looks like it's empty!</Typography>
    </Stack>
  );
};

export default NoTeam;
